/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { CluProjectType } from 'src/clu/core/services/projects/cluProjectSwaggers';
import { AppStore } from 'src/core/stores/app/AppStore';
import { OmitFunctions } from 'src/core/stores/types';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { TranslationDocumentStore } from 'src/translation/stores/TranslationDocumentStore';

export type TranslationJobStoreData = OmitFunctions<Omit<Partial<TranslationJobStore>, 'id' | 'projectName'>>;

export type TranslationStatusType = 'Cancelled' | 'Cancelling' | 'Failed' | 'NotStarted' | 'Running' | 'Succeeded' | 'ValidationFailed';
export class TranslationJobStore extends AppStore {
    public projectType: CluProjectType;

    public id: string;

    public createdDateTimeUtc: Date;

    @observable public lastActionDateTimeUtc: Date;

    @observable public status: TranslationStatusType;

    public documentsNumber: number;

    public error: string;

    public documentStoreHouse = createResourceStoreHouse<TranslationDocumentStore>();

    constructor(id: string, metadata: Partial<TranslationJobStoreData>) {
        super(id, 'translator', metadata);

        this.id = id;
        this.createdDateTimeUtc = metadata.createdDateTimeUtc ?? new Date();
        this.lastActionDateTimeUtc = metadata.lastActionDateTimeUtc ?? new Date();
        this.status = metadata.status;
        this.documentsNumber = metadata.documentsNumber;
        this.error = metadata.error ?? null;
    }

    @action
    public setLastActionDateTimeUtc(lastActionDateTimeUtc: Date) {
        this.lastActionDateTimeUtc = lastActionDateTimeUtc;
    }

    @action
    public setStatus(status: TranslationStatusType) {
        this.status = status;
    }

    @action
    public setError(error: string) {
        this.error = error;
    }
}
